var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import './Table.scss';
import './TablePagination.scss';

export default (function (props) {
    return React.createElement(BootstrapTable, _extends({ bootstrap4: true, classes: 'bs-table table-borderless table-hover', headerClasses: 'bs-header',
        bodyClasses: 'bs-body' }, props));
});